module.exports = __webpack_public_path__ + "static/media/approve.0bc521e7.svg";